export default {
  state: {
    reservationSearch: '',
    reservationFilters: [],
    selectedFilter: '-1',
    date: {
      from: '',
      to: ''
    },
    service: {
      shared: true,
      opoli: true,
      black: true,
      suv: true,
      shuttle: true
    },
    status: {
      upcoming: true,
      ready: true,
      'require-dispatch': true,
      dispatched: true,
      onboard: true,
      completed: true,
      cancelled: true
    }
  },
  mutations: {
    setReservationSearch (state, value) { state.reservationSearch = value },
    resetReservationSearch (state) { state.reservationSearch = '' },
    setReservationFilters (state, filters) { state.reservationFilters = filters },
    setSelectedFilter (state, value) { state.selectedFilter = value },
    setDateFilter (state, data) { state.date[data.fromTo] = data.value },
    setService (state, data) { state.service[data.service] = data.value },
    setStatus (state, data) { state.status[data.status] = data.value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/reservation/reservation-filters.js